module.exports = __webpack_public_path__ + "static/media/aye-loader.8c3df8a9.gif";